"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * A project, which can contain tasks, milestones...
 */
var Project = /** @class */ (function () {
    /**
     * @param name - The project name
     * @param path - The project path
     * @param url - The URL to this project (directly usable in an `<a>` href)
     * @param shortDescription - A human friendly, but short description like `The best project ever`
     * @param avatarUrl - The URL to this project avatar (directly usable in an img src)
     */
    function Project(name, path, url, shortDescription, avatarUrl) {
        this.name = name;
        this.path = path;
        this.url = url;
        this.shortDescription = shortDescription;
        this.avatarUrl = avatarUrl;
    }
    return Project;
}());
exports.Project = Project;
//# sourceMappingURL=Project.js.map